export default {
    id: 'red',
    colors: ['#BA2534', '#FF9580'],
};
